import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { FC } from 'react'

import { useGetMe } from '@/services'
import { APP_ROUTES } from '@/constants.ts'
import { useLastUserId, useUser } from '@/stores/slices/user-slice.ts'

import { useStages } from '../../hooks'

import { VerifyLoginForm } from './verify-login-form.tsx'
import { LoginForm } from './login-form.tsx'

/**
 * 1) Пользователь заходит впервые в ЛК/Пользователь перезагрузил страницу - user = null && lastUserId = null - проверем, что пользователь мог ранее залогиниться
 *    отправляем /me, если тот вернется с 200 - сразу редиректим на базовую страницу, если 403 - показываем форму авторизации
 *
 * 2) Если пользователь был ранее авторизован, но сам нажал на выход - стираем из стора все, кроме lastUserID, чтобы не делать лишний запрос /me, потому что
 *    И так понятно что пользователь вышел - токен будет невалиден - поэтому показываем сразу форму авторизации
 *
 * 3) Если пользователь был ранее авторизован, но протух токен и следующий запрос прислал 403 - стираем из стора информацию о user, оставляем все ранее выставленные
 *    Настройкипагинации и фильтрации пользователя, также оставляем lastUserID - он при повторном входе поможет убедиться - нужно ли дополнительно стирать настройки при авторизации
 *    или нет. Таким образом не делаем доп запрос /me и так понятно, что токен протух
 *
 * 4) Если пользователя, который был ранее авторизован, случайно редиректит на страницу логина - пользователь должен вернуться на базовую страницу
 */

export const LoginPage: FC = () => {
  const { stage, handlePrevStage, handleNextState } = useStages()
  const user = useUser()
  const lastUserId = useLastUserId()

  const shouldFetchMe = !user?.id && !lastUserId

  const { data: { data: userFromMe } = {}, isLoading, isFetched } = useGetMe({ enabled: shouldFetchMe })

  if (user?.id) {
    return <Navigate to={APP_ROUTES.SbpPayments} replace />
  }

  if (lastUserId) {
    return (
      <>
        {stage === 0 && <LoginForm handleNextStage={handleNextState} />}
        {stage === 1 && <VerifyLoginForm handlePrevStage={handlePrevStage} />}
      </>
    )
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          backgroundColor: 'background.default',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
        }}
      >
        <CircularProgress size={50} />
      </Box>
    )
  }

  if (isFetched && userFromMe?.id) {
    return <Navigate to={APP_ROUTES.SbpPayments} replace />
  }

  return (
    <>
      {stage === 0 && <LoginForm handleNextStage={handleNextState} />}
      {stage === 1 && <VerifyLoginForm handlePrevStage={handlePrevStage} />}
    </>
  )
}
